module.exports = __webpack_public_path__ + "img/mhh2.b6f0ec07.jpg";